
// import { useState } from "react"
import { Mail, Linkedin, MapPin } from "lucide-react"
import "../styles/Contact.css"

const Contact = () => {
  // const [formData, setFormData] = useState({
  //   name: "",
  //   email: "",
  //   subject: "",
  //   message: "",
  // })

  // const [formStatus, setFormStatus] = useState({
  //   submitted: false,
  //   success: false,
  //   message: "",
  // })

  // const handleChange = (e) => {
  //   const { name, value } = e.target
  //   setFormData((prev) => ({
  //     ...prev,
  //     [name]: value,
  //   }))
  // }

  // const handleSubmit = (e) => {
  //   e.preventDefault()
  //   // This would normally send the form data to a server
  //   // For demo purposes, we'll just simulate a successful submission
  //   setFormStatus({
  //     submitted: true,
  //     success: true,
  //     message: "Thank you for your message! I will get back to you soon.",
  //   })

  //   // Reset form after submission
  //   setFormData({
  //     name: "",
  //     email: "",
  //     subject: "",
  //     message: "",
  //   })
  // }

  return (
    <div className="contact-container">
      <h1 className="section-title">Contact Me</h1>

      <div className="contact-content">
        <div className="contact-info">
          <div className="contact-card card">
            <h2 className="contact-subtitle">Get In Touch</h2>
            <p className="contact-text">
              I'm always interested in hearing about new projects, opportunities, or just connecting with
              developers. Feel free to reach out using the form or through any of the channels below.
            </p>

            <div className="contact-methods">
              <div className="contact-method">
                <Mail className="contact-icon" />
                <div>
                  <h3>Email</h3>
                  <p>yousefbh@gmail.com</p>
                </div>
              </div>

              <div className="contact-method">
                <Linkedin className="contact-icon" />
                <div>
                  <h3>LinkedIn</h3>
                  <div className="linkedinLink">
                    <a href="https://www.linkedin.com/in/yousef-thulqarnain-b15251269/" >Yousef Thulqarnain</a>
                  </div>
                </div>
              </div>

              <div className="contact-method">
                <MapPin className="contact-icon" />
                <div>
                  <h3>Location</h3>
                  <p>Ann Arbor, MI</p>
                </div>
              </div>
            </div>

            <div className="availability">
              <h3>Current Availability</h3>
              <p>I'm currently available for work and open to discussing new opportunities.</p>
            </div>
          </div>
        </div>

        {/* <div className="contact-form-container">
          <div className="card">
            <h2 className="contact-subtitle">Send Me a Message</h2>

            {formStatus.submitted && (
              <div className={`form-message ${formStatus.success ? "success" : "error"}`}>{formStatus.message}</div>
            )}

            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name" className="form-label">
                  Name
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  className="form-input"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="email" className="form-label">
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  className="form-input"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="subject" className="form-label">
                  Subject
                </label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  className="form-input"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="message" className="form-label">
                  Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  className="form-textarea"
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>

              <button type="submit" className="button button-primary">
                <Send size={16} />
                Send Message
              </button>
            </form>
          </div>
        </div> */}
      </div>
    </div>
  )
}

export default Contact
